export const navMenu = {
  menuItems: [
    { key: 'products', action: 'products' },
    { key: 'search', search: true },
  ],
  linksMain: [
    // { key: 'accountArea', route: { name: 'area-riservata' } },
    { key: 'whyUs', route: { name: 'perche-noi' } },
    { key: 'services', route: { name: 'servizi' } },
    { key: 'company', route: { name: 'azienda' } },
    { key: 'news', route: { name: 'news' } },
    { key: 'resources', route: { name: 'risorse' } },
    { key: 'contacts', route: { name: 'contatti' } },
  ],

  linksSecondary: [
    {
      key: 'privacy',
      route: {
        name: 'privacy-policy',
      },
    },
    {
      key: 'cookie',
      route: {
        name: 'cookie-policy',
      },
    },
    { key: 'copyright', route: { name: 'copyright' } },
    // { key: 'conditions', route: { name: 'condizioni-utilizzo' } },
  ],

  mobileMenu: [
    { key: 'search', search: true },
    { key: 'products', action: 'products' },
    { key: 'whyUs', route: { name: 'perche-noi' } },
    { key: 'services', route: { name: 'servizi' } },
    { key: 'company', route: { name: 'azienda' } },
    { key: 'news', route: { name: 'news' } },
    { key: 'resources', route: { name: 'risorse' } },
    { key: 'contacts', route: { name: 'contatti' } },
  ],
}
